import React from 'react';
import { BenzingaEdgeProvider, EdgeCheckoutHost } from '@benzinga/edge';
import { LoadingScreen } from '@benzinga/core-ui';
import { CustomError } from '@benzinga/templates';

import RootFooter from './root/RootFooter';
import RootHeader from './root/RootHeader';
import RootScripts from './root/RootScripts';
import RootTracker from './root/RootTrackers';
import RegisterEffects from './root/RegisterEffects';
import { MetaProps } from '@benzinga/seo';
import { PageStructuredData } from './root/PageStructuredData';
import { HeaderProps } from '../../src/entities/header';

export interface PageLayoutProps {
  pageProps?:
    | {
        statusCode?: number;
        pageTargeting?: Record<string, string | string[]>;
        disablePushPrompt?: boolean;
        isSSR?: boolean;
        includeAGGridStyles?: boolean;
        disableRaptiveFooter?: boolean;
        disableRaptiveReadyOnPageLoad?: boolean;
        queryParams?: Record<string, string | string[]>;
        headerProps?: HeaderProps;
        embeddedWidget?: boolean;
        error?: number;
        metaProps?: MetaProps;
      }
    | Record<string, any>;
}

export default function PageLayout({
  children,
  pageProps = { isSSR: true },
}: React.PropsWithChildren<PageLayoutProps>) {
  const isSSR = pageProps?.isSSR ?? true;
  return (
    <>
      {pageProps?.metaProps ? <PageStructuredData metaProps={pageProps.metaProps} /> : null}
      <RegisterEffects />
      <RootHeader headerProps={pageProps?.headerProps ?? {}} />
      <RootTracker pageProps={pageProps} />
      <RootScripts pageProps={pageProps} />
      <BenzingaEdgeProvider
        disableRaptiveFooter={pageProps?.disableRaptiveFooter}
        disableRaptiveReadyOnPageLoad={pageProps?.disableRaptiveReadyOnPageLoad}
        initialQueryParams={pageProps?.queryParams}
        initialTargeting={pageProps?.pageTargeting}
      >
        <EdgeCheckoutHost />
        {pageProps?.error ? (
          <CustomError statusCode={pageProps?.error} />
        ) : (
          <>{isSSR ? <>{children}</> : <React.Suspense fallback={<LoadingScreen />}>{children}</React.Suspense>}</>
        )}
      </BenzingaEdgeProvider>
      <RootFooter pageProps={pageProps} />
    </>
  );
}
